import React, { useState, useEffect } from "react";
import DialogCustom from "./DialogCustom";

function ModalAlertConfrim({ 
  open = false,
  title = '',
  subTitle = '',
  content = `มีบางอย่างผิดพลาด`,
  mode = "blue",
  onClose = () => console.log('onClose'),
  onYes = () => console.log('onYes'),
  onNo = () => console.log('onNo')
}) {
  let labelCancel = 'ยกเลิก'
  let colorMode = `blue`
  if (mode === "red") {
    colorMode = mode
    labelCancel = 'ไม่ต้องการยกเลิก'
  }
  return (
    <DialogCustom visible={open} style={{ width: '342px' }} onHide={() => onClose()} onClickOut = {() => onClose()}>
      <div className="modal-header">
        { title ? <h5 className="modal-title" id="staticBackdropLabel" dangerouslySetInnerHTML={{ __html: title }}></h5> : <></> }
      </div>
      <div className="modal-body">
        {subTitle != null && subTitle !== "" ? (
          React.isValidElement(subTitle) ? (
            <div className="mb-0">{subTitle}</div>
          ) : (
            <p className="mb-0">{subTitle}</p>
          )
        ) : null}
        {content != null && content !== "" ? (
          React.isValidElement(content) ? (
            <div className="mb-0">{content}</div>
          ) : (
            <p className="mb-0">{content}</p>
          )
        ) : null}
      </div>
      <div className="modal-footer">
        
        <button 
          type="button" 
          className="btn btn-primary" 
          onClick={() => onYes()}
        >Yes</button>

        <button 
          className="btn btn-light"
          type="button" 
          onClick={() => { onNo()}}
        >No</button>

      </div>
    </DialogCustom>
  )
}

export default ModalAlertConfrim;
